import {
    DateField,
    TextField,
    TextInput,
    BooleanField,
    SelectInput,
    BulkDeleteButton,
    BulkExportButton,
    required,
    BooleanInput
} from 'react-admin';
import { Fragment } from 'react';
import { List, ListActions } from '@react-admin/ra-enterprise';
import { CustomBreadcrumb } from './CustomBreadcrumb';
import { EditableDatagrid, RowForm } from '@react-admin/ra-editable-datagrid';
import FeesField from './FeesField';
import DaemonStatus from './DaemonStatus';

function idRoleAllow(resource_name, action_name) {
    let return_value = 'no';
    let login_role = localStorage.getItem('role');
    if (login_role == 'admin') {
        return 'ok';
    }
    let allpermission = JSON.parse(localStorage.getItem("roles"));
    let roledata = [];
    if (login_role == 'accountant') {
        roledata = allpermission.accountant;
    }
    if (login_role == 'auditor') {
        roledata = allpermission.auditor;
    }
    if (login_role == 'editor') {
        roledata = allpermission.editor;
    }
    roledata.map((role_row, index) => {
        if ((role_row.resource == resource_name) && (role_row.action.indexOf(action_name) > -1)) {
            console.log('operation ok');
            return_value = 'ok';
        }
    });
    return return_value;
}


const SettingsBulkActionButtons = ({ basePath }) => (
    <Fragment>
        {(idRoleAllow('settings', 'export') == 'ok') ?
            <BulkExportButton /> : ''}
        {(idRoleAllow('settings', 'delete') == 'ok') ?
            <BulkDeleteButton basePath={basePath} /> : ''}
    </Fragment>
);

const CryptoCurrencyListActions = (props) => (
    <ListActions  {...props} breadcrumb={<CustomBreadcrumb variant="actions" exporter={(idRoleAllow('settings', 'export') == 'ok') ? true : false} />} />
)

const ECurrencyForm = props => (
    <RowForm {...props}>
        {/* <TextField source="id" label="ID"/> */}
        <TextInput source="full_name" label="Currency" validate={required()} />
        <TextInput source="short_name" autoFocus label="Symbol" validate={required()} />
        <TextInput source="range_from" label="Min amount" validate={required()} />
        <TextInput source="range_to" label="Max amount" validate={required()} />
        <TextInput source="reserve_amount" label="Reserved" validate={required()} />
        <TextInput source="process_fee" label="Process fee" validate={required()} />
        <TextInput source="devalued" label="Devalued" validate={required()} />
        <SelectInput source="auto_payment_active" choices={daemon_choices} label="Daemons" />
        <DateField source="created" label="Date" />
        <SelectInput source="status" choices={status_choices} label="Status" validate={required()} />
    </RowForm>
);

const daemon_choices = [
    { id: true, name: 'Yes' },
    { id: false, name: 'No' }];

const status_choices = [
    { id: true, name: 'Active' },
    { id: false, name: 'Inactive' }];

// const newStyle = makeStyles({
//     tdcolor: { color: '#4f3cc9' }
// });

const Ecurrencies = (props) => {
    //const classes = newStyle();
    return (
        <List
            {...props}
            hasCreate
            empty={false}
            sort={{ field: 'full_name', order: 'ASC' }}
            actions={<CryptoCurrencyListActions />}
            //filters={<CryptoCurrencyFilter />}
            bulkActionButtons={<SettingsBulkActionButtons />}
            //pagination={false}
            title="E-currencies"
        >
            <EditableDatagrid
                className="lastOrdersColumn"
                rowClick="edit"
                createForm={<ECurrencyForm />}
                editForm={<ECurrencyForm />}
            >
                {/* <TextField source="id" label="ID"/> */}
                <TextField source="full_name" label="Currencies" />
                <TextField source="short_name" label="Symbol" />
                <TextField source="range_from_alter" label="Min amount" />
                <TextField source="range_to_alter" label="Max amount" />
                <TextField source="reserve_amount_alter" label="Reserved" />
                <TextField source="process_fee_alter" label="Process fee" />
                <TextField source="devalued_alter" label="Devalued" />
                <DaemonStatus source="auto_payment_active" label="Daemons" />
                <DateField source="created" label="Date" />
                <BooleanField source="status" label="Status" />
            </EditableDatagrid>
        </List>
    )
};
export default Ecurrencies;